export default __webpack_public_path__ + "static/media/calender-evennt-icon.f82132f0.svg";